// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimTransferCreateDto } from './IClaimTransferCreateDto';
import {
    IClaimTransferCreateDtoFromJSON,
    IClaimTransferCreateDtoFromJSONTyped,
    IClaimTransferCreateDtoToJSON,
    IClaimTransferCreateDtoToJSONTyped,
} from './IClaimTransferCreateDto';

/**
 * 
 * @export
 * @interface IClaimTransferCreateBatchDto
 */
export interface IClaimTransferCreateBatchDto {
    /**
     * 
     * @type {Set<IClaimTransferCreateDto>}
     * @memberof IClaimTransferCreateBatchDto
     */
    transfers: Set<IClaimTransferCreateDto>;
    /**
     * 
     * @type {Set<IClaimTransferCreateDto>}
     * @memberof IClaimTransferCreateBatchDto
     */
    repayments: Set<IClaimTransferCreateDto>;
}

/**
 * Check if a given object implements the IClaimTransferCreateBatchDto interface.
 */
export function instanceOfIClaimTransferCreateBatchDto(value: object): value is IClaimTransferCreateBatchDto {
    if (!('transfers' in value) || value['transfers'] === undefined) return false;
    if (!('repayments' in value) || value['repayments'] === undefined) return false;
    return true;
}

export function IClaimTransferCreateBatchDtoFromJSON(json: any): IClaimTransferCreateBatchDto {
    return IClaimTransferCreateBatchDtoFromJSONTyped(json, false);
}

export function IClaimTransferCreateBatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimTransferCreateBatchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'transfers': (new Set((json['transfers'] as Array<any>).map(IClaimTransferCreateDtoFromJSON))),
        'repayments': (new Set((json['repayments'] as Array<any>).map(IClaimTransferCreateDtoFromJSON))),
    };
}

export function IClaimTransferCreateBatchDtoToJSON(json: any): IClaimTransferCreateBatchDto {
    return IClaimTransferCreateBatchDtoToJSONTyped(json, false);
}

export function IClaimTransferCreateBatchDtoToJSONTyped(value?: IClaimTransferCreateBatchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transfers': (Array.from(value['transfers'] as Set<any>).map(IClaimTransferCreateDtoToJSON)),
        'repayments': (Array.from(value['repayments'] as Set<any>).map(IClaimTransferCreateDtoToJSON)),
    };
}

